import apiV1 from "../../services/apiV1";

export const listUsers = (params) =>
  apiV1.get("/users", { params }).then((r) => r.data);

export const createUser = (payload) =>
  apiV1.post("/users", payload).then((r) => r.data.data);

export const updateUser = (userId, payload) =>
  apiV1.patch(`/users/${userId}`, payload).then((r) => r.data.data);

export const getRoles = () => apiV1.get("/users/roles").then((r) => r.data.data);

export const getCustomers = () => apiV1.get("/users/customers").then((r) => r.data.data);

export const getAssignments = (employeeId) =>
  apiV1.get(`/users/${employeeId}/assignments`).then((r) => r.data.data);

export const setAssignments = (employeeId, customerIds) =>
  apiV1.put(`/users/${employeeId}/assignments`, { customerIds }).then((r) => r.data.data);
